export const GET_PROFILE_BG = "GET_PROFILE_BG";

export const CLOSE_DIALOGUE_PROFILE_BG = "CLOSE_DIALOGUE_PROFILE_BG";

export const CERATE_PROFILE_BG = "CERATE_PROFILE_BG";

export const UPDATE_PROFILE_BG = "UPDATE_PROFILE_BG";

export const DELETE_PROFILE_BG = "DELETE_PROFILE_BG";

export const OPEN_DIALOGUE_PROFILE_BG = "OPEN_DIALOGUE_PROFILE_BG";
